import { DotsThreeVertical } from "@phosphor-icons/react";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "./ui/dropdown-menu";

/**
 * Always-visible kebab menu — replaces hover-only buttons.
 *
 * <ItemMenu testId="memory-menu-123" items={[
 *   { label: "Edit", icon: PencilSimple, onClick: ... },
 *   { type: "separator" },
 *   { label: "Delete", icon: Trash, onClick: ..., destructive: true },
 * ]} />
 */
export default function ItemMenu({ items, testId, align = "end", buttonClassName = "" }) {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button
          type="button"
          aria-label="More actions"
          data-testid={testId}
          onClick={(e) => e.stopPropagation()}
          className={`p-1.5 rounded-md text-white/50 hover:text-white hover:bg-white/5 transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-cyan-500/40 ${buttonClassName}`}
        >
          <DotsThreeVertical size={16} weight="bold" />
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent
        align={align}
        sideOffset={6}
        className="bg-[#161616] border-white/10 text-white min-w-[180px]"
      >
        {items.map((it, i) => {
          if (it.type === "separator")
            return <DropdownMenuSeparator key={i} className="bg-white/5" />;
          const Icon = it.icon;
          return (
            <DropdownMenuItem
              key={i}
              onClick={(e) => {
                e.stopPropagation();
                it.onClick?.(e);
              }}
              data-testid={it.testId}
              className={`gap-2 cursor-pointer ${
                it.destructive
                  ? "text-red-400 focus:text-red-300 focus:bg-red-500/10"
                  : "focus:bg-white/5"
              }`}
            >
              {Icon && <Icon size={14} weight="duotone" />}
              <span>{it.label}</span>
            </DropdownMenuItem>
          );
        })}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
